document.addEventListener('DOMContentLoaded', function () {
    initHamburger();
    updateCartCount();
    initQuantityControls();
    initHeroCarousel();
    translateJudgemeButton();
    initFilters();
});

function initHamburger() {
    const hamburger = document.getElementById('hamburgerBtn');
    const navLinks = document.getElementById('navLinks');

    if (!hamburger || !navLinks) return;

    hamburger.addEventListener('click', function () {
        this.classList.toggle('active');
        navLinks.classList.toggle('open');
    });

    navLinks.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
            hamburger.classList.remove('active');
            navLinks.classList.remove('open');
        });
    });
}

function updateCartCount() {
    fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
            var count = document.getElementById('cart-count');
            if (count) count.textContent = cart.item_count;
        })
        .catch(function () {});
}

function addToCart(variantId) {
    if (!variantId) return;

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (res) {
        if (!res.ok) {
            return res.json().then(function (err) {
                throw new Error(err.description || 'Error al agregar el producto');
            });
        }
        return res.json();
    })
    .then(function () {
        updateCartCount();
        // Redirect to cart page or just let the cart count update silently
        window.location.href = '/cart';
    })
    .catch(function (error) {
        alert(error.message);
    });
}

function addToCartWithQty(variantId, qty) {
    if (!variantId || !qty) return;

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
    })
    .then(function (res) {
        if (!res.ok) {
            return res.json().then(function (err) {
                throw new Error(err.description || 'Error al agregar el producto');
            });
        }
        return res.json();
    })
    .then(function () {
        updateCartCount();
        window.location.href = '/cart';
    })
    .catch(function (error) {
        alert(error.message);
    });
}

function changeCardQty(buttonEl, variantId, change) {
    var container = buttonEl.parentElement;
    var valueEl = container.querySelector('.card-qty-value');
    var currentVal = parseInt(valueEl.textContent) || 0;
    var newVal = currentVal + change;
    if (newVal < 0) return;

    // Disable buttons to prevent duplicate requests
    var buttons = container.querySelectorAll('button');
    buttons.forEach(function(btn) { btn.disabled = true; });

    // Update UI immediately
    valueEl.textContent = newVal;

    var url = (currentVal === 0 && newVal > 0) ? '/cart/add.js' : '/cart/change.js';
    var payload = { id: variantId.toString(), quantity: newVal };

    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    })
    .then(function (res) {
        if (!res.ok) {
            return res.json().then(function (err) {
                throw new Error(err.description || 'Error al actualizar el carrito');
            });
        }
        return res.json();
    })
    .then(function (cart) {
        updateCartCount();
        if (window.location.pathname === '/cart') {
            window.location.reload();
        }
    })
    .catch(function (error) {
        // Revert UI on failure
        valueEl.textContent = currentVal;
        alert(error.message);
    })
    .finally(function() {
        // Re-enable buttons
        buttons.forEach(function(btn) { btn.disabled = false; });
    });
}

function initQuantityControls() {
    document.addEventListener('click', function (e) {
        var target = e.target.closest('.qty-btn');
        if (!target || target.disabled) return;

        var id = target.getAttribute('data-variant-id');
        var change = parseInt(target.getAttribute('data-change'));
        var qtyEl = target.parentElement.querySelector('.qty-value');
        var currentQty = parseInt(qtyEl.textContent);
        var newQty = currentQty + change;

        if (newQty <= 0) {
            removeCartItem(id);
            return;
        }

        // Disable buttons in this container during processing
        var container = target.parentElement;
        var buttons = container.querySelectorAll('.qty-btn');
        buttons.forEach(function(btn) { btn.disabled = true; btn.style.opacity = '0.5'; });

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: newQty })
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
            qtyEl.textContent = newQty;
            updateCartCount();
            updateCartSummary(cart);
        })
        .catch(function () {})
        .finally(function() {
            // Re-enable
            buttons.forEach(function(btn) { btn.disabled = false; btn.style.opacity = ''; });
        });
    });

    document.addEventListener('click', function (e) {
        var target = e.target.closest('.remove-btn');
        if (!target) return;

        var id = target.getAttribute('data-variant-id');
        removeCartItem(id);
    });
}

function removeCartItem(variantId) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
        updateCartCount();
        window.location.reload();
    })
    .catch(function () {});
}

function updateCartSummary(cart) {
    var subtotalEl = document.querySelector('.summary-row .subtotal-value');
    var totalEl = document.querySelector('.summary-row.total .value');
    var countEl = document.querySelector('.item-count');
    var itemCountEl = document.getElementById('cart-count');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (countEl) countEl.textContent = cart.item_count + ' producto' + (cart.item_count !== 1 ? 's' : '');
    if (itemCountEl) itemCountEl.textContent = cart.item_count;
}

function formatMoney(cents) {
    if (!cents) cents = 0;
    var value = (cents / 100).toLocaleString('es-CO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
    return '$' + value + ' COP';
}

function initHeroCarousel() {
    var carousel = document.querySelector('.hero-carousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.hero-slide');
    var dots = carousel.querySelectorAll('.hero-dot');
    var dotsContainer = carousel.querySelector('.hero-dots');
    if (slides.length <= 1) return;

    var autoplaySpeed = parseInt(carousel.getAttribute('data-autoplay-speed')) || 5000;
    var currentSlideIndex = 0;
    var timer = null;

    function showSlide(index) {
        // Remove active class from current elements
        slides[currentSlideIndex].classList.remove('active');
        if (dots.length > 0) {
            dots[currentSlideIndex].classList.remove('active');
        }

        // Add active class to new elements
        slides[index].classList.add('active');
        if (dots.length > 0) {
            dots[index].classList.add('active');
        }

        // Handle light/dark dots for background image contrast
        if (dotsContainer) {
            var contentContainer = slides[index].querySelector('.hero-slide-content');
            if (contentContainer && contentContainer.classList.contains('has-bg-image')) {
                dotsContainer.classList.add('light-dots');
            } else {
                dotsContainer.classList.remove('light-dots');
            }
        }

        currentSlideIndex = index;
    }

    function nextSlide() {
        var nextIndex = (currentSlideIndex + 1) % slides.length;
        showSlide(nextIndex);
    }

    function startAutoplay() {
        if (timer) clearInterval(timer);
        timer = setInterval(nextSlide, autoplaySpeed);
    }

    function stopAutoplay() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }

    // Initialize dots click events
    dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
            var targetIndex = parseInt(this.getAttribute('data-slide-index'));
            if (targetIndex === currentSlideIndex) return;
            showSlide(targetIndex);
            // Reset autoplay timer when clicked
            startAutoplay();
        });
    });

    // Hover events to pause autoplay
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Initial check for light dots on load
    var initialContent = slides[0].querySelector('.hero-slide-content');
    if (dotsContainer && initialContent && initialContent.classList.contains('has-bg-image')) {
        dotsContainer.classList.add('light-dots');
    }

    // Start autoplay loop
    startAutoplay();
}

function translateJudgemeButton() {
    var translate = function() {
        var btns = document.querySelectorAll('.jdgm-write-rev-link');
        btns.forEach(function(btn) {
            var text = btn.textContent.trim().toLowerCase();
            if (text === 'write a review') {
                btn.textContent = 'Escribir una reseña';
            }
        });
    };

    translate();

    var target = document.getElementById('judgeme_product_reviews');
    if (target) {
        var observer = new MutationObserver(function() {
            translate();
        });
        observer.observe(target, { childList: true, subtree: true });
    } else {
        var docObserver = new MutationObserver(function(mutations, obs) {
            var el = document.getElementById('judgeme_product_reviews');
            if (el) {
                translate();
                var observer = new MutationObserver(function() {
                    translate();
                });
                observer.observe(el, { childList: true, subtree: true });
                obs.disconnect();
            }
        });
        docObserver.observe(document.body, { childList: true, subtree: true });
    }
}

/* ===== FILTER LOGIC ===== */
function initFilters() {
    var grid = document.querySelector('.products-grid');
    if (!grid) return;

    var pathname = window.location.pathname;
    var params = new URLSearchParams(window.location.search);
    var hasPrechecked = false;

    // Detect if pathname is /collections/kits or query param category=kits
    if (pathname.endsWith('/kits') || params.get('category') === 'kits' || params.get('category') === 'Kits') {
        var kitsCheckbox = document.querySelector('input[value="Kits"][data-filter="category"]');
        if (kitsCheckbox) {
            kitsCheckbox.checked = true;
            hasPrechecked = true;
        }
    }

    var skinTypeParam = params.get('skin-type');
    if (skinTypeParam) {
        var skinCb = document.querySelector('input[value="' + skinTypeParam + '"][data-filter="skin-type"]');
        if (skinCb) {
            skinCb.checked = true;
            hasPrechecked = true;
        }
    }

    var prodTypeParam = params.get('prod-type');
    if (prodTypeParam) {
        var prodCb = document.querySelector('input[value="' + prodTypeParam + '"][data-filter="prod-type"]');
        if (prodCb) {
            prodCb.checked = true;
            hasPrechecked = true;
        }
    }

    if (hasPrechecked) {
        applyFilters();
    }
}

function toggleFilterGroup(btn) {
    btn.classList.toggle('active');
    var content = btn.nextElementSibling;
    if (content) {
        content.classList.toggle('open');
        var icon = btn.querySelector('.filter-group-icon');
        if (icon) {
            icon.textContent = content.classList.contains('open') ? '-' : '+';
        }
    }
}

function applyFilters() {
    var cards = document.querySelectorAll('.products-grid .product-card');
    if (cards.length === 0) return;

    // Get checked categories
    var checkedCategories = Array.from(document.querySelectorAll('input[data-filter="category"]:checked')).map(function (cb) {
        return cb.value;
    });

    // Get checked skin types
    var checkedSkinTypes = Array.from(document.querySelectorAll('input[data-filter="skin-type"]:checked')).map(function (cb) {
        return cb.value;
    });

    // Get checked product types
    var checkedProdTypes = Array.from(document.querySelectorAll('input[data-filter="prod-type"]:checked')).map(function (cb) {
        return cb.value;
    });

    var visibleCount = 0;

    cards.forEach(function (card) {
        var cardCategory = card.getAttribute('data-category');
        var cardSkinType = card.getAttribute('data-skin-type');
        var cardProdType = card.getAttribute('data-prod-type');

        var categoryMatch = checkedCategories.length === 0 || checkedCategories.indexOf(cardCategory) !== -1;
        var skinTypeMatch = checkedSkinTypes.length === 0 || 
                            checkedSkinTypes.indexOf(cardSkinType) !== -1 || 
                            cardSkinType === 'Todo tipo de piel';
        var prodTypeMatch = checkedProdTypes.length === 0 || checkedProdTypes.indexOf(cardProdType) !== -1;

        if (categoryMatch && skinTypeMatch && prodTypeMatch) {
            card.style.display = '';
            visibleCount++;
        } else {
            card.style.display = 'none';
        }
    });

    // Update count display
    var countEl = document.getElementById('active-products-count');
    if (countEl) {
        countEl.textContent = visibleCount + ' producto' + (visibleCount !== 1 ? 's' : '');
    }

    // Toggle no results messages
    var noFilteredMsg = document.getElementById('no-filtered-products-msg');
    var noProductsMsg = document.getElementById('no-products-msg');

    if (visibleCount === 0) {
        if (noFilteredMsg) noFilteredMsg.style.display = 'block';
        if (noProductsMsg) noProductsMsg.style.display = 'none';
    } else {
        if (noFilteredMsg) noFilteredMsg.style.display = 'none';
    }
}

